import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';

const theme = DesignSystem.extendBase(
  {
    sizes: {
      footer: '50px',
      topbar: '80px',
    },
  },
  {
    accent: '#115A97',
    tone: {
      error: '#B21010',
    },
  },
);
DesignSystem.setTheme('base-plus', theme);
DesignSystem.useTheme('base-plus');
